'use client';

export default function HtmlContent({html, mobile}: {html: any; mobile: any}) {
  if (!mobile) {
    return <>{html}</>;
  } else {
    return (
      <>
        <div className="hidden md:block">{html}</div>
        <div className="md:hidden">{mobile ?? html}</div>
      </>
    );
  }
}
